<template>
  <div class="robot-box">
    <img
      v-if="isOpenTip"
      class="robot"
      src="@/assets/home/robot_talk@2x.png"
    >
    <img
      v-else
      class="robot"
      src="@/assets/home/robot_sleep@2x.png"
    >
    <Transition name="bounce">
      <div
        v-if="isOpenTip"
        class="tip"
      >
        <p class="content">
          {{ content }}
        </p>
        <p class="author">
          {{ author }}
        </p>
      </div>
    </Transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isOpenTip: true,
      content: '',
      author: '',
    };
  },
  created() {
    setInterval(() => {
      this.changeTips();
    }, 10000);
    this.play();
  },
  methods: {
    changeTips() {
      this.content = '';
      this.author = '';
      this.isOpenTip = !this.isOpenTip;
      this.play();
    },
    play() {
      const self = this;
      const content = '要降温了，大家记得添加衣服，不要感冒了哦！';
      const author = '——行政小天使';
      for (let i = 0; i < content.length; i++) {
        window.setTimeout(() => {
          self.content += content[i];
        }, 200 * i);
      }
      for (let i = 0; i < author.length; i++) {
        window.setTimeout(() => {
          self.author += author[i];
        }, 200 * (content.length + i));
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/utils.scss";
@import "@/styles/font/font.scss";
@import "@/styles/animation/robot_pupup.scss";
.robot-box {
  .robot {
    position: absolute;
    top: 64%;
    left: 33.8%;
    width: widthToPerc(120);
    height: heightToPerc(147);
  }
  .tip {
    position: absolute;
    top: 63%;
    left: 37%;
    padding: 15px 8px 15px 25px;
    width: widthToPerc(446);
    height: heightToPerc(202);
    background-image: url("../../assets/home/tips_bg.png");
    background-size: 100%;
    background-repeat: no-repeat;
    p {
      font-family: Ftiebihei;
      font-size: 14px;
      line-height: 18px;
      letter-spacing: 0px;
      color: #ffffff;
    }
    .content {
      text-align: left;
      height: 36px;
    }
    .author {
      text-align: right;
      line-height: 24px;
    }
  }
}
</style>
